import React, {useRef, useState, useEffect} from "react"
import './GooglePlaceAutocomplete.scss'
import { Loader } from '@googlemaps/js-api-loader';
import placeFields from './placeFields'

const GooglePlaceAutocomplete = ({apiKey, name, placeholder, resetError, onChange, onResetField}) =>
{
    let autocomplete
    let listener
    
    const field = useRef() 
    const button = useRef() 
    const [thekey, setThekey] = useState(Math.random())
    const [render, setRender] = useState(()=>{})
    const [fieldName, setFieldName] = useState('google-place-autocomplete-input')
    
    const loader = new Loader({
        apiKey: apiKey,
        version: "weekly",
        libraries: ["places"]
    });           
    
    const hiddenFields = (fields) =>
    {
        setRender(()=>
        {    
            return(
                fields.map(field =>
                {                    
                    return(<input type="text" name={field[0]} value={field[1]}/>)
                })                
            )
        })
    }

    const placeChanged = () =>
    {        
        if(resetError) resetError()
        if(onChange) onChange(placeFields(autocomplete))
        hiddenFields(placeFields(autocomplete))    
    } 

    const restartField = () =>
    {
        if(typeof window !== "undefined") window.google.maps.event.removeListener(listener)
        setRender(()=>{})
        const temp = field.current.value 
        setThekey(Math.random())
        field.current.value = temp
        if(resetError) resetError()
    }

    const resetField = (e) =>
    {
        e.preventDefault()    
        
        if(onResetField) onResetField(e)

        restartField()        
    }

    useEffect(()=>
    { 
        if(typeof window !== "undefined")
        {
            window.gm_authFailure = () =>
            {
                console.log('Google Api Error')
                setFieldName(name || 'google-place-autocomplete-input')
                restartField()
            }
        }

        if(resetError) resetError()
                
        loader
        .load()
        .then((google) => 
        {                         
            autocomplete = new google.maps.places.Autocomplete(field.current, {
                types: ["address"],
                componentRestrictions: { country: ["US"] },
                fields: [],
            }) 
    
            listener = autocomplete.addListener("place_changed", placeChanged) 
        })
        .catch(e => 
        {            
            console.log(e)
        });

    },[thekey])

    return (
        <div className="google-place-autocomplete">
            <input key={thekey} ref={field} placeholder={placeholder||''} name={fieldName} />
            <button className="google-place-autocomplete-clear" ref={button} onClick={resetField}><span>x</span></button>
            <div className="hidden-fields">{render}</div>
        </div>
    )
}

export default GooglePlaceAutocomplete;